import dollarFormat from "../../dollar-format";

export const offeringSummary = {
    name: 'OFFERING SUMMARY',
    rows: []
};

export const proformaRequirements = {
    header: [ 'PROFORMA CAPITAL REQUIREMENTS', '', 'AMOUNT', 'PSF'],
    rows: []
};

export const incomeAndExpenses = {
    header: [ 'INCOME & EXPENSES', '', 'CURRENT', 'PSF'],
    rows: [],
    footer: ['NET OPERATING INCOME', '', '' , '']
};

export const incomeAndExpensesAsIS = {
    header: ['INCOME & EXPENSES (As Is)', '', 'CURRENT', 'PSF'],
    rows: [],
    footer: ['NET OPERATING INCOME', '', '' , '']
};

export const incomeAndExpensesProforma = {
    header: ['INCOME & EXPENSES (ProForma)', '', 'PROFORMA', 'PSF'],
    rows: [],
    footer: ['NET OPERATING INCOME', '', '' , '']
};


export const rentRoll = {
    header: ['Suite', 'Tenant', 'Sq Ft', '% of Sq Ft', 'Start', 'End', 'Annual Rent', 'PSF', 'Escalation Date', 'Escalation Amount', 'Options', 'Lease Type'],
    rows: [],
    footer: [
        ['', 'Occupied', '', '', '', '', '', '', '', '', '', ''],
        ['', 'Vacant', '', '', '', '', '', '', '', '', '', ''],
        ['', 'Total', '', '', '', '', '', '', '', '', '', ''],
    ]
};

export const getOfferingSummaryData = function(tabs, precomputedValues) {
    const isProformaCheck = tabs['pricing-tab'].tables['pricing-analysis'].rows['proforma-checkbox'].valueCells[1].value == true;
    return [{
        label: 'Price',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['price'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, {
        label: isProformaCheck ? 'Cap Rate (As Is)' : 'Cap Rate',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['cap-rate'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, {
        label: isProformaCheck ? 'Net Operating Income (As Is)' : 'Net Operating Income',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['net-operating-income'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, 
    ...( isProformaCheck ?
        [{
            label: 'Cap Rate (Proforma)',
            value: tabs['marketing-tab'].tables['offering-summary'].rows['proforma-cap-rate'].getComputedValue(tabs, '', precomputedValues).displayValue
        },
        {
            label: 'Net Operating Income (Proforma)',
             value: tabs['marketing-tab'].tables['offering-summary'].rows['net-operating-income-proforma'].getComputedValue(tabs, '', precomputedValues).displayValue
        }]
     : ''),
    {
        label: 'Price PSF',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['price-psf'].getComputedValue(tabs, '', precomputedValues).displayValue
    },
    
    {
        label: 'Occupancy',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['occupancy'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, {
        label: 'Year Built',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['year-built'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, {
        label: 'Gross Leasable Area',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['gross-leasable-area'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, {
        label: 'Acres',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['lot-size'].getComputedValue(tabs, '', precomputedValues).displayValue
    }];
};

export const getIncomeAndExpenses = function(tabs, precomputedValues) {
    const incomeExpenses = incomeAndExpenses;
    const rows = tabs['marketing-tab'].tables['income-and-expenses'].rows;
    const keys = Object.keys(rows);
    // remove last element which is an the empty row
    keys.pop();
    incomeExpenses.rows = keys.map(key => {
        return {
            valueCells: new Array(4).fill(null).map((cell, cellIndex) => {
                if (key === 'base-rent-lease-up-space' && cellIndex === 1 || !rows[key].valueCells[cellIndex].hasOwnProperty('getComputedValue')) {
                    return {
                        value: ''
                    }
                }

                if (key === 'mgmt-fee' && cellIndex === 0) {
                    return {
                        value: 'Mgmt. Fee'
                    }
                }
                if (key === 'vacancy-factor' && cellIndex === 0) {
                    return {
                        value: 'Vacancy Factor (economic)'
                    }
                }
                if (key === 'expenses-mgmt-fee' && cellIndex === 0) {
                    return {
                        value: 'Mgmt. Fee (% of GPI)'
                    }
                }

                const value = rows[key].valueCells[cellIndex].getComputedValue(tabs, key, precomputedValues).displayValue;
                const displayValue = value !== '-' ? value : (cellIndex > 1 ? '$0.00' : '0.00%');
                return {
                    value: displayValue
                }
            })
        }
    });

    const footerRow = tabs['marketing-tab'].tables['income-and-expenses'].footerRow;
    incomeExpenses.footer[2] = footerRow.valueCells[2].getComputedValue(tabs, '', precomputedValues).displayValue;
    const psf = footerRow.valueCells[3].getComputedValue(tabs, '', precomputedValues).displayValue;
    incomeExpenses.footer[3] = `${psf.toLocaleString()}`;

    return incomeExpenses;
};

export const getincomeAndExpensesAsIS = function(tabs, precomputedValues) {
    const incomeExpensesAsIS = incomeAndExpensesAsIS;
    const rows = tabs['marketing-tab'].tables['income-and-expenses'].rows;
    const keys = Object.keys(rows);
    // remove last element which is an the empty row
    keys.pop();
    incomeExpensesAsIS.rows = keys.map(key => {
        return {
            valueCells: new Array(4).fill(null).map((cell, cellIndex) => {
                if (key === 'base-rent-lease-up-space' && cellIndex === 1 || !rows[key].valueCells[cellIndex].hasOwnProperty('getComputedValue')) {
                    return {
                        value: ''
                    }
                }

                if (key === 'mgmt-fee' && cellIndex === 0) {
                    return {
                        value: 'Mgmt. Fee'
                    }
                }
                if (key === 'vacancy-factor' && cellIndex === 0) {
                    return {
                        value: 'Vacancy Factor (economic)'
                    }
                }
                if (key === 'expenses-mgmt-fee' && cellIndex === 0) {
                    return {
                        value: 'Mgmt. Fee (% of GPI)'
                    }
                }

                const value = rows[key].valueCells[cellIndex].getComputedValue(tabs, key, precomputedValues).displayValue;
                const displayValue = value !== '-' ? value : (cellIndex > 1 ? '$0.00' : '0.00%');
                return {
                    value: displayValue
                }
            })
        }
    });

    const footerRow = tabs['marketing-tab'].tables['income-and-expenses'].footerRow;
    incomeExpensesAsIS.footer[2] = footerRow.valueCells[2].getComputedValue(tabs, '', precomputedValues).displayValue;
    const psf = footerRow.valueCells[3].getComputedValue(tabs, '', precomputedValues).displayValue;
    incomeExpensesAsIS.footer[3] = `${psf.toLocaleString()}`;

    return incomeExpensesAsIS;
};

export const getincomeAndExpensesProforma = function(tabs, precomputedValues) {
    const incomeExpensesProforma = incomeAndExpensesProforma;
    const rows = tabs['marketing-tab'].tables['proforma-income-and-expenses'].rows;
    const keys = Object.keys(rows);
    // remove last element which is an the empty row
    keys.pop();
    incomeExpensesProforma.rows = keys.map(key => {
        return {
            valueCells: new Array(4).fill(null).map((cell, cellIndex) => {
                if (!rows[key].valueCells[cellIndex].hasOwnProperty('getComputedValue')) {
                    return {
                        value: ''
                    }
                }

                if (key === 'mgmt-fee' && cellIndex === 0) {
                    return {
                        value: 'Mgmt. Fee'
                    }
                }
                if (key === 'vacancy-factor' && cellIndex === 0) {
                    return {
                        value: 'Vacancy Factor (economic)'
                    }
                }
                if (key === 'expenses-mgmt-fee' && cellIndex === 0) {
                    return {
                        value: 'Mgmt. Fee (% of GPI)'
                    }
                }

                const value = rows[key].valueCells[cellIndex].getComputedValue(tabs, key, precomputedValues).displayValue;
                const displayValue = value !== '-' ? value : (cellIndex > 1 ? '$0.00' : '0.00%');
                return {
                    value: displayValue
                }
            })
        }
    });

    const footerRow = tabs['marketing-tab'].tables['proforma-income-and-expenses'].footerRow;
    incomeAndExpensesProforma.footer[2] = footerRow.valueCells[2].getComputedValue(tabs, '', precomputedValues).displayValue;
    const psf = footerRow.valueCells[3].getComputedValue(tabs, '', precomputedValues).displayValue;
    incomeAndExpensesProforma.footer[3] = `${psf.toLocaleString()}`;

    return incomeAndExpensesProforma;
};


export const getProformaRequirementsData = function(tabs, precomputedValues) {
    const proformaTabRequirements = proformaRequirements;
    const rows = tabs['pricing-tab'].tables['proforma-capital-req'].rows;
    const keys = Object.keys(rows);
    keys.push('proforma-adjusted-basis-yeild');
    keys.push('proforma-adjusted-basis-total');

    // remove last element which is an the empty row
    proformaTabRequirements.rows = keys.map(key => {
        return {
            valueCells: new Array(4).fill(null).map((cell, cellIndex) => {
                if (key == 'proforma-adjusted-basis-total') {
                    if (cellIndex == 0) {                        
                        const value = rows['total'].valueCells[0].getComputedValue(tabs,  precomputedValues).displayValue == "Proforma Adjusted Basis COC Return" ? "Proforma Adjusted Basis Cash on Cash" : '-';
                        const displayValue = value !== '-' ? value : '-';
                        return {
                            value: displayValue
                        }
                    } 
                    if (cellIndex == 1) {
                        
                        const value = rows['total'].valueCells[2].getComputedValue(tabs,  precomputedValues).displayValue;
                        const displayValue = value !== '-' ? value : '';
                        return {
                            value: ""
                        }
                    } 
                    if (cellIndex == 2) {                        
                        const value = rows['total'].valueCells[1].getComputedValue(tabs,  precomputedValues).displayValue;
                        const displayValue = value !== '-' ? value : (cellIndex > 1 ? '$0.00' : '0.00%');
                        return {
                            value: displayValue
                        }
                    } 
                    else  {
                    
                        const value = rows['total'].valueCells[cellIndex + 0].getComputedValue(tabs, precomputedValues).displayValue;
                        const displayValue = value !== '-' ? value : (cellIndex > 1 ? '$0.00' : '0.00%');
                        return {
                            value: displayValue
                        }
                    }
                    
                }
                if (key == 'proforma-adjusted-basis-yeild') {
                    if (cellIndex == 0) {
                        const value = rows['adjusted-basis'].valueCells[0].getComputedValue(tabs, precomputedValues).displayValue;
                        const displayValue = value !== '-' ? value : '-';
                        return {
                            value: displayValue
                        }
                    }
                    if (cellIndex == 1) {                        
                        const value = rows['adjusted-basis'].valueCells[2].getComputedValue(tabs,  precomputedValues).displayValue;
                        const displayValue = value !== '-' ? value : '';
                        return {
                            value: displayValue
                        }
                    } 
                    if (cellIndex == 2) {                        
                        const value = rows['adjusted-basis'].valueCells[1].getComputedValue(tabs,  precomputedValues).displayValue;
                        const displayValue = value !== '-' ? value : (cellIndex > 1 ? '$0.00' : '0.00%');
                        return {
                            value: displayValue
                        }
                    } 
                    else {
                        const value = rows['adjusted-basis'].valueCells[cellIndex + 0].getComputedValue(tabs, precomputedValues).displayValue;
                        const displayValue = value !== '-' ? value : (cellIndex > 1 ? '$0.00' : '0.00%');
                        return {
                            value: displayValue
                        }
                    }
                }
                if (key !== 'proforma-adjusted-basis-yeild' && key !== 'proforma-adjusted-basis-total') {

                    const value = rows[key].valueCells[cellIndex + 4].getComputedValue(tabs, key, precomputedValues).displayValue;
                    let displayValue=value;
                    displayValue = value !== '-' ? value : (cellIndex > 1 ? '$0.00' : '0.00%');
                    if (key=='total') {
                       if (rows[key].valueCells[cellIndex + 4].getComputedValue(tabs, key, precomputedValues).displayValue == "Total") {
                           displayValue = "Total:";
                       }
                    }
                    if (key=='adjusted-basis') {
                        const value = rows[key].valueCells[cellIndex + 4].getComputedValue(tabs, key, precomputedValues).displayValue == "Adjusted Basis" ? "ADJUSTED BASIS" : "-";
                        displayValue = value !== '-' ? value : (cellIndex > 1 ? '' : '');
                    }
                    return {
                        value: displayValue
                    }
                    
                }
            })
        }
    });
    return proformaTabRequirements;
};



export const getRentRoll = function(tabs, precomputedValues) {
    const newRentRoll = rentRoll;
    const generalRows = tabs['current-rr-tab'].tables['general-information'].rows;
    const summedGeneralRows = tabs['current-rr-tab'].tables['sumed-general-information'].rows;
    const rentRows = tabs['marketing-tab'].tables['rent-roll'].rows;
    const summedRentRows = tabs['marketing-tab'].tables['sumed-rent-roll'].rows;
    const dateIndexes = [1, 2, 5]; // 1 - Start; 2 - End; 5 - Escalation Date
    const annualRentIndex = 3;
    const leaseTypeIndex = 8;

    newRentRoll.rows = Object.keys(generalRows).map(key => {
        const valueCells = [];
        let index = 0;

        const cellNo = generalRows[key].valueCells.length;
        generalRows[key].valueCells.map((cell, cellIndex) => {
            if (cellIndex === cellNo - 1 || cellIndex === cellNo - 2)
                return;
            let value = cell.value;
            if (cellIndex === cellNo - 3)
                value = cell.value.toLocaleString();
            valueCells[index] = {value: value};
            index++;
        });
        try{
        rentRows[key].valueCells.map((cell, cellIndex) => {
            let {internalValue, displayValue} = cell.getComputedValue(tabs, key, precomputedValues);
            if (cellIndex === leaseTypeIndex && displayValue.includes('NNN')) {
                valueCells[index] = {value: 'NNN'};
                return;
            }
            if (cellIndex === annualRentIndex) {
                valueCells[index++] = {
                    value: internalValue ?
                        dollarFormat(internalValue)
                        :
                        '-'
                };
                return;
            }
            if (dateIndexes.includes(cellIndex) && displayValue) {
                displayValue = displayValue.split('');
                displayValue.splice(6, 2);
                displayValue = displayValue.join('');
            }
            valueCells[index++] = {value: displayValue};
        });
    }
    catch(err){
        console.log(err);
    }
        return {valueCells: valueCells};
    });

    const generalRowsKeys = Object.keys(summedGeneralRows);
    generalRowsKeys.pop();
    generalRowsKeys.map((key, index) => {
        summedGeneralRows[key].valueCells.map((cell, cellIndex) => {
            if (!cell.hasOwnProperty('empty') && cellIndex > 0)
                newRentRoll.footer[index][cellIndex] = cell.getComputedValue(tabs, key, precomputedValues).displayValue;
        });
    });

    Object.keys(summedRentRows).map((key, index) => {
        if (summedRentRows[key].valueCells)
            summedRentRows[key].valueCells.map((cell, cellIndex) => {
                if (key === 'first-row' && cellIndex === annualRentIndex) {
                    const value = cell.getComputedValue(tabs, key, precomputedValues).internalValue;
                    newRentRoll.footer[index][cellIndex + generalRowsKeys.length] = value ? dollarFormat(value) : '-';
                    return;
                }
                if (!cell.hasOwnProperty('empty'))
                    newRentRoll.footer[index][cellIndex + generalRowsKeys.length] = cell.getComputedValue(tabs, key, precomputedValues).displayValue;
            });
    });
    newRentRoll.rows.forEach(row => {
        row.valueCells.splice(10, 1); // Remove the element at index 1
      });
    return newRentRoll;
};
